export default __webpack_public_path__ + "static/media/phoneBlock2_tablet.158362c1.png";